"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.symbol = symbol;
function symbol() {
    // eslint-disable-next-line max-len,quotes
    return '<symbol viewbox="0 0 16 16" id=icon-heart-filled-16><path d="M6.552 1.483c.48.244.96.588 1.448 1.053.489-.465.968-.81 1.448-1.053A4.409 4.409 0 0 1 11.5 1c1.55 0 2.709.634 3.461 1.554C15.688 3.443 16 4.55 16 5.5c0 .918-.348 1.711-.704 2.292a7.23 7.23 0 0 1-.978 1.237c-4.201 4.335-4.913 5.014-5.628 5.695l-.01.01a.997.997 0 0 1-1.36 0l-.01-.01c-.715-.681-1.426-1.36-5.628-5.695a7.228 7.228 0 0 1-.978-1.237C.348 7.212 0 6.418 0 5.5c0-.95.311-2.057 1.039-2.946C1.79 1.634 2.95 1 4.5 1c.625 0 1.311.107 2.052.483Z"></path></symbol>';
}
